<!--
   Created by qing on 2020/12/23
   Des: 在小程序点击置顶项目，会先进入到该页面，再由这个页面进入到真正的node_list页面，这样处理是为了解决返回拦截的问题
-->
<template>
  <div></div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {
      this.$router.push({
        name: 'mixFormNodeList',
        query: {
          mixFormId: this.$route.query.mixFormId
        }
      })
    },
    methods: {}
  }
</script>

<style lang="less">

</style>